import { render, staticRenderFns } from "./page-music-categories.vue?vue&type=template&id=e61eb860"
import script from "./page-music-categories.vue?vue&type=script&lang=ts"
export * from "./page-music-categories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports